import React from 'react';
import {
	Modal,
	ModalBody,
	ModalFooter,
} from 'reactstrap';
import close from '../assets/close.png';

const ModalClose = ({
	confirmIsOpen, 
	backdrop,
	confirmCloseNative, 
	textSuccess, 
	textError, 
	confirmClose, 
	confirmSuccess, 
	textHeader, 
	textReason}) => {
	return (
		<Modal className="modal-message align-items-center justify-content-center" backdrop={backdrop} size='sm' isOpen={confirmIsOpen} toggle={() => confirmClose()}>
			<ModalBody className="pb-2" style={{minHeight: '120px'}}>
				<div className="d-flex flex-column align-items-center align-items-center">
					<img src={close} alt='close' style={{width: '70px'}} />
				</div>
			</ModalBody>
			<div>
				<span className="btn-small d-block text-center mt-4" id="toggler">
					Keluar Registrasi
				</span>
				<center className="align-middle" style={{padding: '0 1.2rem'}}>
					<label className="small">
						Apakah Anda yakin ingin membatalkan proses registrasi akun?
					</label>
				</center>
			</div>
			<ModalFooter className='text-center'>
				<button className="btn btn-outline-primary" 
					style={{bottom: '6%', borderRadius: '10px', height: '50px', marginRight: '8px'}} 
					onClick={() => confirmClose()}>
					Kembali
				</button>
				<button className="btn btn-primary" 
					style={{bottom: '6%', borderRadius: '10px', height: '50px', marginLeft: '8px'}} 
					onClick={() => confirmCloseNative()}>
					Iya, Batal
				</button>
			</ModalFooter>
		</Modal>
	);
}

export default ModalClose
